import { Quotes } from "@phosphor-icons/react";

export default function OwnerBehavior() {
  return (
    <section className="py-12">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <div className="rounded-3xl border border-cvc-border bg-white p-10 md:p-14 relative overflow-hidden">
          <Quotes size={64} weight="duotone" className="absolute top-6 right-6 text-cvc-red/15" />
          <p className="text-xs tracking-[0.3em] uppercase font-body font-semibold text-cvc-red">Owner behavior matters</p>
          <h2 className="font-heading text-3xl md:text-4xl text-cvc-navy mt-3 leading-tight">
            Scaling up is a joint effort. Your behavior, support, and scaling-compatible choices are the difference between a great ending and a stalled one.
          </h2>
          <p className="font-body text-cvc-ink-soft text-lg mt-5 leading-relaxed">
            We bring the framework, the structure, and the experience. You bring the willingness to delegate,
            to follow advice that may not feel intuitive at first, and to act in a way that lets the company outgrow your old habits.
            When those two halves meet — that's where great endings happen.
          </p>
        </div>
      </div>
    </section>
  );
}
